import MuiDivider, {DividerProps} from '@mui/material/Divider'

export const Divider = (props: DividerProps) => {
    return (
        <MuiDivider {...props} />
    )
}